import {AfterViewInit, Component, ElementRef, EventEmitter, Input, NgZone, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {AnimationOptions} from 'ngx-lottie';
import {Subject} from 'rxjs';
import {DatePipe} from '@angular/common';
import {debounceTime, distinctUntilChanged, takeUntil} from 'rxjs/operators';
import {PolicyService} from '../../../policy/services/policy.service';
import {PolicyQuery} from '../../../policy/state/policy.query';
import {FlowPlayerService} from '../../../shared/services/flow-player.service';

declare var accounting: any;
declare var $: any;
declare var noUiSlider: any;
declare var wNumb: any;

declare function initPopover(): any;

@Component({
    selector: 'app-question-edit',
    templateUrl: './question-edit.component.html',
    styleUrls: ['./question-edit.component.scss'],
    standalone: false
})
export class QuestionEditComponent implements OnInit, OnDestroy, AfterViewInit {

  private unsubscribe$ = new Subject<void>();
  radioSelected: any;
  @Input() question: any;
  @Input() item: any;
  @Input() session_id!: string;
  @Input() group: any;
  @Input() readOnly = false;
  @Output() dataToPass: EventEmitter<any> = new EventEmitter<any>();
  @Output() questionAnswer: EventEmitter<any> = new EventEmitter<any>();


  private customStepper$ = new Subject<number>();

  private geoCoder: any;
  lottieOptions: AnimationOptions = {
    path: 'assets/everything-insure-loader.json',
  };
  policy: any;
  accounting: any;
  latitude = 0;
  longitude = 0;
  @ViewChild('search')
  public searchElementRef!: ElementRef;
  marker: any = [];
  zoom = 12;
  map = false;
  spinner = false;
  center!: google.maps.LatLngLiteral;
  options: google.maps.MapOptions = {
    // mapTypeId: 'hybrid',
    zoomControl: false,
    scrollwheel: false,
    disableDoubleClickZoom: true,
    maxZoom: 15,
    minZoom: 8,
  };

  comingFromUW = false;
  selectDropdownValue = '';

  constructor(
    private policyQuery: PolicyQuery,
    private policiesService: PolicyService,
    private ngZone: NgZone,
    public datePipe: DatePipe,
    private flowPlayer: FlowPlayerService
  ) {
    this.policy = this.policyQuery.getActive();

  }

  setStep(step: number, question: any): void {
    const newStep = Number(question.answer) + step;

    if (Number(question.val_min) <= newStep && Number(question.val_max) >= newStep) {
      question.answer = newStep;
      // saveAnswer is called in a debouncing subscription (executed below in the subject) in ngAfterViewInit.
      this.customStepper$.next(newStep);
    }
  }

  ngOnInit(): void {
    // window['angularComponentReference'] = { component: this, zone: this.ngZone, loadAngularFunction: () => this.saveAnswer(), };
    // //console.log('this.question IN COMPONENT: ', this.question)
    this.comingFromUW = this.group === 'uw';
    // //console.log('this.comingFromUW: ', this.comingFromUW);
    accounting.settings = {
      currency: {
        symbol: 'R ', // default currency symbol is '$'
        format: '%s%v', // controls output: %s = symbol, %v = value/number (can be object: see below)
        decimal: '.', // decimal point separator
        thousand: ' ', // thousands separator
        precision: 0, // decimal places
      },
      number: {
        precision: 0, // default precision on numbers is 0
        thousand: ' ',
        decimal: '.',
      }
    };
    this.accounting = accounting;
    // if (this.question.question_id == 575) {
    //   this.question.val_max = 100000;
    //   this.question.val_min = 0;
    // }

  }

  ngOnDestroy(): void {
    if (this.customStepper$) {
      this.customStepper$.complete();
    }
  }

  trackByFn(index: number, option: any): any {
    return index ? index : 0;
  }

  ngAfterViewInit(): void {
    // Wait a bit for all the stuff to load then trigger js scripts, is there a better way?
    // setTimeout( ()=> {
    this.customStepper$.pipe(
      debounceTime(2000),
      distinctUntilChanged()
    ).subscribe((value: number) => {
      this.question.answer = value;
      // //console.log('in debouncer: ', value);
      this.saveAnswer();
    });
    setTimeout(() => {
      const selectId = `#dropdown-${this.question.index}`;
      $(selectId).selectmenu({
        change: (event: any, data: any) => {
          this.selectDropdownValue = data?.item?.value;
          this.question.answer = this.selectDropdownValue;
          // //console.log('in here1');
          this.saveAnswer();
        }
      });
      $('#category').selectmenu({
        change: (event: any, data: any) => {
          this.selectDropdownValue = data?.item?.value;
          this.question.answer = this.selectDropdownValue;
          // //console.log('in here2');
          this.saveAnswer();
        }
      });
    }, 2000);


    $.each($('.multiselect'), (i: any, c: any) => {
      if (c.checked && $(c).attr('data-answer') === 'None of the above') {
        const $siblingCtrls = $(c)
          .closest('.custom-input--checkbox')
          .siblings('.custom-input--checkbox')
          .find('input[type="checkbox"]');
        $siblingCtrls.prop('disabled', true);
        // console.log(c)
      }
    });
    // initCustomStep();
    // }, 100);
    try {
      if (this.question.question_type_id === 3) {
        this.googleMap();
      }
    } catch (e) {
    }
    if (this.question.question_type_id === 7 && this.question.question_id === 576) {
      if (this.question.options !== '') {
        $.each(JSON.parse(this.question.options), (i: number, o: any) => {
          $('#radioBoxes').append(`
            <label class="custom-input custom-input--radio custom-input--pill">
            <input value="${o.answer}" type="radio" (click)="checkRadio('${o.answer}')" name="radio-${this.question.question_id}[]"/>
            <span class="custom-input__indi"></span>
            <span class="custom-input__label">${o.answer}</span>
        </label>
          `);
        });
      }

    }

    if (this.question.question_type_id === 49 && this.question.answer.indexOf('None of the above') >= 0) {
      $.each($('.multiselect'), (i: number, el: any) => {
        el.checked = false;
        $(el).prop('disabled', true);
        if (el.value === 'None of the above') {
          el.checked = true;
        }
      });
    }
    initPopover();
  }

  googleMap(): void {
    this.geoCoder = new google.maps.Geocoder;
    this.geoCoder.geocode({address: this.question.answer}, (results: { geometry: { location: any; }; }[], status: string) => {
      if (status === 'OK') {
        this.ngZone.run(() => {
          this.map = true;
          $('.spinner').hide();
          this.latitude = results[0].geometry.location.lat();
          this.longitude = results[0].geometry.location.lng();
          this.center = {
            lat: this.latitude,
            lng: this.longitude,
          };
          this.marker = {
            position: {
              lat: this.latitude,
              lng: this.longitude,
            },
            options: {animation: google.maps.Animation.DROP},
          };
        });

      }
    });
    const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
    autocomplete.addListener('place_changed', () => {
      this.ngZone.run(() => {
        const place: google.maps.places.PlaceResult = autocomplete.getPlace();

        if (place.geometry === undefined || place.geometry === null) {
          return;
        }

        this.latitude = place.geometry.location.lat();
        this.longitude = place.geometry.location.lng();
        this.zoom = 12;
        this.marker = {
          position: {
            lat: this.latitude,
            lng: this.longitude,
          },
          options: {animation: google.maps.Animation.DROP},
        };
        this.center = {
          lat: this.latitude,
          lng: this.longitude,
        };
        this.center = {
          lat: this.latitude,
          lng: this.longitude,
        };
      });
    });
  }

  startFlow(): void {
    this.policiesService.saveAnswer(this.session_id, 1073, 0, '0', '6', 0).pipe(takeUntil(this.unsubscribe$))
      .subscribe(result => {
          this.flowPlayer.startFlow(0, this.question.dependant_flow_id, this.policy.product_category_id, this.policy.product_group_id, this.question.item_id, this.session_id,'',0);
        },
        err => {
          console.log(err);
          this.spinner = false;
        });

  }

  checkRadio(answer: string): void {
    console.log(this.question);
    if (this.checkDisabledQuestions(this.question.question_id)) {
      $('#modal-additional').modal('show');
    } else {
      this.question.answer = answer;
      this.saveAnswer();
    }

  }

  checkAllrisk(): void {
    const category = $('#category').val();
    const description = $('#description').val();
    const amount = $('#amount').val();
    this.question.answer = category + '|' + this.stripCurrency(amount) + '|' + description;
    this.saveAnswer();
  }

  checkMultiSelect(): void { // None of the above should disbaled the rest of the options
    let answers = '';
    $.each($('.multiselect'), (i: number, el: any) => {
      if (el.checked) {
        if (el.value === 'None of the above') {
          const $siblingCtrls = $(this)
            .closest('.custom-input--checkbox')
            .siblings('.custom-input--checkbox')
            .find('input[type="checkbox"]');
          $siblingCtrls.prop('disabled', true);
          answers = el.value;
        } else {
          answers += el.value + '|';
        }

      } else {
        if (el.value === 'None of the above') {
          const $siblingCtrls = $(el)
            .closest('.custom-input--checkbox')
            .siblings('.custom-input--checkbox')
            .find('input[type="checkbox"]');
          $siblingCtrls.prop('disabled', false);
          // answers = answers.replace("None of the above","");
        }
      }

    });
    if (answers.slice(-1) === '|') {
      this.question.answer = answers.slice(0, -1);
    } else {
      this.question.answer = answers;
    }

    // //console.log(this.question)
    if (this.question.answer !== '') {
      // //console.log('in here5');
      this.saveAnswer();
    }
  }

  stripCurrency(text: string): string {
    try {
      return text.replace(/ /g, '').replace('R', '');
    } catch (e) {
      return text;
    }
  }

  checkDisabledQuestions(i: number): boolean {
    let arr = Array<number>();
    // List of questions that can't be changed
    arr = [40, 41, 47, 50, 57, 71, 73, 74, 75, 84, 268, 519, 523, 566, 508];
    if (arr.indexOf(i) >= 0) {
      return true;
    } else {
      return false;
    }
  }

  getButtonOptions(): any {
    if (this.question.options !== '') {
      try {
        //// console.log(JSON.parse(this.question.options))
        return JSON.parse(this.question.options);
      } catch (e) {
        return this.question.options;
      }
    }


  }

  getOptions(): any {

    if (this.question.options !== '') {
      //// console.log(JSON.parse(this.question.options))
      return JSON.parse(this.question.options);
    } else {
      return [];
    }
  }

  saveSliderValue(sliderData: any): void {
    // //console.log('SLIDER SAVE: ', this.stripCurrency(this.question.answer), this.stripCurrency(sliderData?.sliderValue));
    if (this.stripCurrency(this.question.answer) !== this.stripCurrency(sliderData?.sliderValue)) {
      this.question.answer = this.stripCurrency(sliderData?.sliderValue);
      // //console.log(this.question);
      // //console.log('in here6');
      this.saveAnswer();
    }
  }

  saveAnswer(): void {
    const answer = this.question.answer;

    // //console.log('IN QUESTION EDIT ANSWER: ', answer, this.question);
    this.questionAnswer.emit(this.question);

    if (this.comingFromUW) {
      return;
    }

    this.spinner = true;
    this.policiesService.saveAnswer(this.session_id, this.question.question_id, this.question.class_id, this.question.item_id, answer, 0).pipe(takeUntil(this.unsubscribe$))
      .subscribe(result => {
          let today: any;
          today = this.datePipe.transform(new Date(), 'YYYY-MM-dd');
          this.policiesService.calcPremDiff(this.session_id, today).pipe(takeUntil(this.unsubscribe$))
            .subscribe(response => {
                this.dataToPass.emit(response);
                this.spinner = false;
              },
              err => {
                // console.log(err);
                this.spinner = false;
              });
        },
        err => {
          // console.log(err);
          this.spinner = false;
        });
  }

  getDescriptionIndex(text: string, index: number): string {
    if (!text) {
      return '';
    }
    const t = text.split('|');
    return t[index];
  }
}

